import { Outlet } from "@tanstack/react-router";
import { useEffect } from "react";
import { AppProvider } from "../context/app-context.tsx";
import { SettingsProvider } from "../context/settings-context.tsx";
import { installScannerBridge } from "../scanner-bridge.ts";
import { ScanDebug } from "../components/scan-debug.tsx";

const showDebug =
  typeof window !== "undefined" && new URLSearchParams(window.location.search).has("debug");

export function Root() {
  useEffect(() => {
    installScannerBridge();
  }, []);

  return (
    <AppProvider>
      <SettingsProvider>
        {showDebug && <ScanDebug />}
        <div className="flex h-full flex-col bg-gray-950 text-white">
          <Outlet />
        </div>
      </SettingsProvider>
    </AppProvider>
  );
}
